import React, {useEffect, useState} from 'react'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {VendorProfile} from './VendorPrfile'
import {DocumentsAndCompliance} from './DocumentsAndCompliance'
import { useAuth } from '../../contexts/auth.context'
import { getSearcherCompany } from '../../services/order.service'
import { useLocation, useNavigate } from 'react-router-dom'

type StateProps = {
  searchCompanyId: number
  companyIcon: string
  tab: string
}

const VendorProfileWrapper: React.FC = () => {
  const [active, setActive] = useState('Documents & Compliance');
  const {auth} = useAuth();
  const [searchCompanyId, setSearchCompanyId] = useState<number | null>(null);
  const [companyIcon, setCompanyIcon] = useState("");
  const location = useLocation();
  const navigate =useNavigate();
  
  useEffect(() => {
    if(location.state) {
      const stateProps = location.state as StateProps;
      setSearchCompanyId(Number(stateProps.searchCompanyId));
      setCompanyIcon((location?.state as any)?.companyIcon);
      setActive(stateProps?.tab)
    }
      else if (auth?.email) {
        getSearcherCompany().then((res) => {
          setSearchCompanyId(res?.success?.msg[0]?.searcher_SCOMP_ID)
        })
      }
    }, [])

  return (                  
    <>
      <button
        type='button'
        onClick={() => navigate(-1)}
        style={{
          width: 'fit-content',
          marginBottom: '2.5rem',
          background: 'none',
          border: 'none',
          padding: 0,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <i className="fa-solid fa-arrow-left me-3 fs-1 text-primary lh-1"></i>
        <h5 className='fw-light m-0 lh-1'>Go Back</h5>
      </button>

    <div className='vendorProfile card bg-white' style={{border: 'solid 1px #E8E8E8'}}>
      <div className='row mb-5'>
        <div className='col-12' style={{paddingTop: 20, paddingLeft: 20}}>
          <div className='d-flex justify-content-between align-items-center'>
            <h3 className='text-primary fw-normal mx-1 my-1 d-flex align-items-center'>
              <img
                src={toAbsoluteUrl('/media/ATR/icons/Vendor Profile.png')}
                alt='header-icon'
                className='h-40px me-4 my-3'
              />
              {'Settings'}
            </h3>
          </div>
          <ul className='nav nav-tabs px-3'>
            <li className='nav-item'>
              <button
                type='button'
                className={`nav-link ${active === 'Profile' ? 'active' : ''}`}
                onClick={() => setActive('Profile')}
              >
                Profile
              </button>
            </li>
            <li className='nav-item'>
              <div style={{display: 'flex', alignItems: 'center'}}>
                <button
                  type='button'
                  className={`nav-link ${active === 'Documents & Compliance' ? 'active' : ''}`}
                  onClick={() => setActive('Documents & Compliance')}
                >
                  Documents & Compliance
                </button>
                {companyIcon && (
              <img
                src={`/media/ATR/icons/${companyIcon}`}
                alt='status'
                style={{ width: 35, height: 35, display: 'block' }}
              />
            )}
              </div>
            </li>
          </ul>

          {/* Tab Content */}
          <div className='mt-4'>
            {active === 'Profile' && (
              <div>
                <VendorProfile searchCompanyId = {searchCompanyId ?? 0}/>
              </div>
            )}
            {active === 'Documents & Compliance' && <DocumentsAndCompliance searchCompanyId = {searchCompanyId ?? 0} />}
          </div>
        </div>
      </div>
    </div>
    </>
  )
}

export {VendorProfileWrapper}
